module.exports = __webpack_public_path__ + "9c9386a082eb9b22f6444bcf3b27ca72.svg";